<template>
  <cube-button
    class="mt10"
    icon="like"
    tip="辅助文案"
    primary
    outline
  >主要文案</cube-button>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({})
</script>

<style lang="stylus">
.mt10
  margin-top 10px
  display block
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index"
    }
  }
</script>
